import { createFileRoute } from "@tanstack/react-router";

export { JobDetailsPanel as JobDrawerDetailsPanel } from "@/features/jobs/components/job-details-panel";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/_drawer/details",
)({
	/** Tab body is composed by the drawer layout into Figma `Details`. */
	component: () => null,
});
